import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect, useState } from "react";
import "../styles/carousel.css"; // 👈 Custom styling

const images = [
  {
    src: "/Jitish-kallat-Public-Notice-3-Art-Institute-of-Chicago-2011-4-scaled.jpg",
    text: {
      title: "Art India Education",
      description:
        "Created for both beginners and professionals, Art India Education’s exclusive video series explores Indian art through conversations, masterclasses, and interviews with eminent personalities of art in India.",
      button: "SUBSCRIBE NOW",
      button_url: "membership-plan",
    },
  },
  {
    src: "/1200px-Anish_Kapoor_en_el_Museo_Universitario_Arte_Contemporaneo_-i-i-_27268244445.jpg",
    text: {
      title: "Engage with Experts",
      description:
        "After 25 years of engaging with modern & contemporary Indian art, ART India Magazine introduced Art India Education – a premier online art platform curated by industry experts.",
      button: "READ MORE",
      button_url: "faculty",
    },
  },
  {
    src: "/Banner-slider-4-backkground.jpg",
    text: {
      title: "Explore Season One",
      description: `How did modern India’s most creative minds come together to usher in the subcontinent’s most daring period of art? Discover perspectives & stories, nuanced histories & anecdotes related to the Progressive Art Movement and the development of Indian Modern Art.`,
      button: "SUBSCRIBE NOW",
      button_url: "membership-plan",
    },
  },
  {
    src: "/Subodh-Gupta-NGMA-2014-Photo-©Ram-Rahman_8912-scaled.jpg",
    text: {
      title: "Explore Season Two",
      description: `Discover the dynamic world of contemporary Indian art! Leading art industry experts take us on an insightful journey to understand its intricacies – exploring diverse themes, mediums and styles through the works of established and emerging artists.`,
      button: "SUBSCRIBE NOW",
      button_url: "membership-plan",
    },
  },
];

const ImageCarousel = ({ onSlideChange }) => {
  const [fadeIn, setFadeIn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => setFadeIn(true), 500);
  }, []);

  return (
    <section className="relative h-screen w-full overflow-hidden flex items-center justify-center">
      <Swiper
    modules={[Navigation, Pagination]}
    navigation
    pagination={{ clickable: true }}
    loop={true}
    onSlideChange={(swiper) => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const isCustom = activeSlide.classList.contains("white-slide");
      onSlideChange(isCustom);  // true if white-slide
    }}
    className="h-full w-full"
  >

        {/* Slide 1 */}
        <SwiperSlide key={0} className="relative w-full h-full font-['EB_Garamond','Nunito','sans-serif']">
          <img src={images[0].src} className="absolute w-full h-full object-cover z-0" alt="slide" />
          <div className="absolute inset-0 bg-black/60 bg-gradient-to-t from-white/30 to-transparent z-10" />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-center z-20">
            <h3 className={`text-7xl font-bold transition-opacity duration-1000 ${fadeIn ? "opacity-100" : "opacity-0"}`}>
              {images[0].text.title}
            </h3>
            <p className={`mt-4 text-2xl max-w-2xl mx-auto transition-opacity duration-1000 ${fadeIn ? "opacity-100" : "opacity-0"}`}>
              {images[0].text.description}
            </p>
            <button
              className="mt-6 text-white text-xl font-bold border-b-2 border-[#EA7E5D] hover:bg-[#EA7E5D] px-6 py-2"
              onClick={() => navigate(`/${images[0].text.button_url}`)}
            >
              {images[0].text.button}
            </button>
          </div>
        </SwiperSlide>

        {/* Custom Card Slide */}
        <SwiperSlide className="relative w-full h-full white-slide font-['EB_Garamond','Nunito','sans-serif'] bg-white">
          <div className="h-full w-full flex flex-col md:flex-row items-center justify-center gap-12 px-12 py-12 text-black">
              <img
                src="/Sangita-Jindal-min.jpg"
                alt="Custom Card Icon"
                style={{ width: '330px', height: '330px', objectFit: 'contain' }}
              />
            <div className="text-center md:text-left max-w-xl">
      
              <p className="text-2xl mb-4 leading-relaxed text-justify">
              “Over the last 27 years, ART India has played an important role in the world of South Asian art. It has created a forum for inspired interaction between artists, critics, historians, architects, writers and collectors and has had a definitive impact on the community.”
              </p>
              <p className="text-xl pb-6 whitespace-pre-line">
                {`Sangita Jindal
            Chairperson of JSW Foundation
            and Founder of Art India Magazine & Art India Education`}
              </p>
              <button
                className="text-[rgb(234,126,93)] text-lg font-semibold border-b-2 border-[rgb(234,126,93)] hover:bg-[rgb(234,126,93)] hover:text-white px-6 py-2 transition duration-300"
                onClick={() => navigate("/membership-plan")}
              >
                READ MORE
              </button>
            </div>
          </div>
        </SwiperSlide>
        {images.slice(1).map((image, index) => (
          <SwiperSlide key={index} className="relative w-full h-full">
            <img
              src={image.src}
              alt={`Slide ${index + 1}`}
              className="absolute inset-0 w-full h-full bg-white/100 object-cover z-0"
            />

            {/* Overlay for visibility */}
            <div className="absolute inset-0 z-10 bg-black/20 bg-gradient-to-t from-black/80 via-black/60 to-transparent pointer-events-none" />
            {/* Text Content */}
            <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6 z-20 font-['EB_Garamond','Nunito','sans-serif']">
              <h3 className={`text-7xl font-bold mb-3 pb-10 transition-opacity duration-1000 ${fadeIn ? "opacity-100" : "opacity-0"}`}>
                {image.text.title}
              </h3>
              <p className={`text-2xl max-w-3xl leading-snug mb-6 transition-opacity duration-1000 ${fadeIn ? "opacity-100" : "opacity-0"}`}>
                {image.text.description}
              </p>
              <button
                className="text-white text-xl font-bold relative group p-1"
                onClick={() => navigate(`/${image.text.button_url}`)}
              >
                <span className="pb-1 p-2 border-b-2 font-bold border-[#EA7E5D] group-hover:bg-[#EA7E5D] group-hover:text-white transition-all duration-300">
                  {image.text.button}
                </span>
              </button>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ImageCarousel;
